var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar2"},[_c('div',{staticStyle:{"width":"100%","height":"200px"},attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }